import OfficeFragment from '@/lib/fragments/office'
import SectionPaddingFragment from '@/lib/fragments/section-padding'
import { graphql } from '@/lib/query'

const SectionOfficeFragment = graphql(
  /* GraphQL */ `
    fragment SectionOfficeFragment on SectionOfficeRecord {
      id
      title
      __typename
      hide
      bg
      _modelApiKey
      sectionPadding {
        ...SectionPaddingFragment
      }
      mapZoom
      offices {
        ...OfficeFragment
      }
    }
  `,
  [OfficeFragment, SectionPaddingFragment]
)

export default SectionOfficeFragment
